import { render } from "./nav-menu.vue?vue&type=template&id=46578a22&scoped=true&ts=true"
import script from "./nav-menu.vue?vue&type=script&lang=ts"
export * from "./nav-menu.vue?vue&type=script&lang=ts"

import "./nav-menu.vue?vue&type=style&index=0&id=46578a22&scoped=true&lang=css"

import exportComponent from "/vercel/path2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46578a22"]])

export default __exports__